<template>
  <div class="my-4">
    <b-alert dismissible
             fade
             :show="isError"
             @dismissed="clearLoginError"
             variant="danger">
      {{errorMessage}}
      <template slot="dismiss" class="pull-right">
        &nbsp;
      </template>
    </b-alert>

    <b-alert dismissible
             fade
             :show="isInfo"
             @dismissed="clearLoginInfo"
             variant="info">
      {{infoMessage}}
      <template slot="dismiss" class="pull-right">
        &nbsp;
      </template>
    </b-alert>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
  name: "LoginAlert",
  methods: mapActions([
      'clearLoginError',
      'clearLoginInfo',
  ]),
  computed: mapState({
    isError: state => !!state.auth.loginError.length,
    isInfo: state => !!state.auth.loginInfo.length,
    errorMessage: state => state.auth.loginError,
    infoMessage: state => state.auth.loginInfo,
  })
}
</script>

<style scoped>

</style>
